import React from "react";
import AccesoSimultaneo from './AccesoSimultaneo.jsx';

const AccesoSimultaneoLista = (props) => {
    let accesosSimultaneosNodes;
    let showMessage = false;

    if (props.accesosSimultaneos && props.accesosSimultaneos.length > 0) {
        accesosSimultaneosNodes = props.accesosSimultaneos.filter(x => x.ValidCanLog);

        accesosSimultaneosNodes = accesosSimultaneosNodes.map(function (sa, index) {
            return (<AccesoSimultaneo data={sa} key={index} />)
        });
    } else {
        showMessage = true;
        accesosSimultaneosNodes = null;
    }

    let stylePP = {
        fontFamily: 'Roboto-Regular',
        fontSize: '16px',
        color: '#141414'
    }
    let _plataforma = props.accesosSimultaneos.find(x => x.TipoPlataformaId == props.usuario.PlataformaId).Descripcion;
    return (
        <div>
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">{"Accesos m\u00E1ximos simult\u00E1neos por tipo de plataforma"}</label>
                </div>
                {showMessage == false ?
                    <div className="col-xs-12">
                        <ul className="list-unstyled">{accesosSimultaneosNodes}</ul>
                    </div> : null}
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <label className="label-primary">Plataforma predeterminada:</label>
                </div>
                <div className="col-xs-12">
                    <li>
                        <label style={stylePP}>{_plataforma}</label>
                    </li>
                </div>
            </div>

        </div>
    );
}

export default AccesoSimultaneoLista;
